import axios from 'axios';
import { API_BASE_URL } from '../config/api';

const API_BASE = `${API_BASE_URL}/api/allocations`;

export const allocationService = {
  // Get all rules
  getRules: async (filters = {}) => {
    const params = new URLSearchParams();
    if (filters.e_ledger_id) params.append('e_ledger_id', filters.e_ledger_id);
    if (filters.active !== undefined) params.append('active', filters.active);
    const response = await axios.get(`${API_BASE}/rules?${params}`);
    return response.data;
  },

  // Get rule by ID
  getRuleById: async (id) => {
    const response = await axios.get(`${API_BASE}/rules/${id}`);
    return response.data;
  },

  // Create rule
  createRule: async (data) => {
    const response = await axios.post(`${API_BASE}/rules`, data);
    return response.data;
  },

  // Update rule
  updateRule: async (id, data) => {
    const response = await axios.put(`${API_BASE}/rules/${id}`, data);
    return response.data;
  },

  // Delete rule
  deleteRule: async (id) => {
    const response = await axios.delete(`${API_BASE}/rules/${id}`);
    return response.data;
  },

  // Execute allocation
  execute: async (data) => {
    const response = await axios.post(`${API_BASE}/execute`, data);
    return response.data;
  },

  // Get executions
  getExecutions: async (filters = {}) => {
    const params = new URLSearchParams();
    if (filters.e_ledger_id) params.append('e_ledger_id', filters.e_ledger_id);
    const response = await axios.get(`${API_BASE}/executions?${params}`);
    return response.data;
  },

  // Get execution by ID
  getExecutionById: async (id) => {
    const response = await axios.get(`${API_BASE}/executions/${id}`);
    return response.data;
  }
};

export default allocationService;
